/* eslint-disable no-shadow */
export enum NavAction {
  'replace' = 'replace',
  'push' = 'push',
  'pop' = 'pop',
  'navigate' = 'navigate',
}
